import { Backdrop } from "@mui/material";
import CenterCircularLoading from "./CenterCircularLoading";

export const FullPageLoading = ({ open }) => (
  <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={open}>
    <CenterCircularLoading />
  </Backdrop>
)